import { FormField, SelectProps, Steps } from '@cloudscape-design/components';
import { mdiHumanMaleBoard } from '@mdi/js';
import Icon from '@mdi/react';
import React, { useEffect, useState } from 'react';
import { formatDate } from '../../pages/commons/functions';
import { useGlobalState } from '../../pages/context/GlobalStateContext';
import { ItemCheck } from '../../resources/types';
import Copy from '../Copy';



interface StepsCheckProps {
    check: ItemCheck;
}

const StepsCheck: React.FC<StepsCheckProps> = ({
    check
}) => {

    const { menu, idUser } = useGlobalState();

    const [localCheck, setLocalCheck] = useState<ItemCheck>(check);
    const [selectedStatusOption, setSelectedStatusOption] = useState<SelectProps.Option | null>(null);
    useEffect(() => {
        setLocalCheck(check)
    }, [check]);
    return (
        <Steps
            steps={[
                {
                    status: "not-started",
                    header: <>Solicitud #{localCheck.idRequest} <Copy value={localCheck.idRequest.toString()} showText={false} /></>,
                    details: (
                        <FormField label={localCheck.check}>
                            {formatDate(localCheck.dateSubmited) ?? ""}
                        </FormField>
                    ),
                },
                {
                    // 1. Fixed: Explicitly cast the dynamic ternary statuses
                    status: (localCheck.idInstructor === 0 ? "loading" : "info") as "loading" | "info",
                    header: localCheck.idInstructor === 0 ? <em>Esperando asignación...</em> : <strong><Icon path={mdiHumanMaleBoard} size={0.75} /> {localCheck.instructor}</strong>,
                    details: localCheck.idInstructor === 0 ? undefined : formatDate(localCheck.dateAssigned),
                },
                ...(localCheck.statusRequest === 1 ? [{
                    // 2. Fixed: Explicitly cast the dynamic process status
                    status: "loading" as const,
                    header: "Resultado",
                    details: "Esperando evaluación...",
                }] : []),
                ...(localCheck.statusRequest === 3 ? [{
                    // 2. Fixed: Explicitly cast the dynamic process status
                    status: "success" as const,
                    header: "Aprobado",
                    details: formatDate(localCheck.dateResult),
                }] : []),
                ...(localCheck.statusRequest === 2 ? [{
                    // 2. Fixed: Explicitly cast the dynamic process status
                    status: "error" as const,
                    header: "Rechazado",
                    details: formatDate(localCheck.dateResult),
                }] : []),

                ...(localCheck.statusRequest === -1 ? [{
                    status: "error" as const, // 3. Fixed: Use 'as const' to lock the literal type
                    header: "Anulado",
                    details: formatDate(localCheck.dateResult),
                }] : [])
            ]}
        />
    );


};

export default StepsCheck;
